import HTTPError from './HTTPError.js'

export default class APIError extends HTTPError {
  constructor (id, status, message) {
    super(status, message)
    this.id = id
    this.name = 'APIError'
  }
}
